module.exports = __webpack_public_path__ + "img/dni-black.5479770c.svg";